<script>
  export let text = "Se ti sembra strano che il <strong>totale delle percentuali non dia 100</strong> ricorda che alcune news parlano sia di Meloni che di Schlein."
</script>
  <p class="note">{@html text}</p>
<style>
  .note {
    font-size: 80%;
    font-style: italic;
  }
</style>